import type { PropsWithChildren } from 'react'
import { memo } from 'react'

type Props = PropsWithChildren<
  {
    isRequired?: boolean
  } & JSX.IntrinsicElements['label']
>

export const Label = memo<Props>(({ children, className = '', isRequired = false, ...props }) => {
  return (
    <label className={`flex items-center gap-x-4 mb-2 ${className}`} htmlFor="name">
      <span className="font-bold">{children}</span>
      <span
        className={`rounded-full border-2 border-bg-blue ${
          isRequired ? 'bg-bg-blue text-white' : 'bg-white text-bg-blue'
        } text-xs px-3 py-1 leading-none`}
      >
        {isRequired ? '必須' : '任意'}
      </span>
    </label>
  )
})
